import { Input, Row, Typography, Col, Tooltip } from "antd";
import React, { useState, useEffect } from "react";
import "./ResetPassword.css";
import { LoginOutlined, InfoCircleOutlined } from "@ant-design/icons";
import PFButton from "../../../components/functional_components/Button/PFButton";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import PasswordStrenght from "../../../components/functional_components/PasswordStrenght/PasswordStrenght";
import { showError, showSuccess } from "../../../utils/utilities";
import { useSelector } from "react-redux";
import { get } from "lodash";
import { initUsername } from "../../../redux/ducks/UserInfo";
import { useDispatch } from "react-redux";
import Authentication from "../../../services/api/Authentication";

const ResetPassword = () => {
  const { t } = useTranslation();
  const { Text } = Typography;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const username = useSelector((state) => get(state.userInfoDuck, "username", ""));

  useEffect(() => {
    if (username === "") {
      navigate("/login");
    }
  });

  const formikLogin = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    },
    validate: (values) => {
      let errors = {};
      if (!values.oldPassword) {
        errors.oldPassword = "Required!";
      }
      if (!values.newPassword) {
        errors.newPassword = "Required!";
      }
      if (!values.confirmNewPassword) {
        errors.confirmNewPassword = "Required!";
      }
      return errors;
    },
    onSubmit: (values) => {
      if (values.newPassword === values.confirmNewPassword) {
        handleSubmit(values);
      } else {
        showError(t("resetPassword.checkPassword"));
      }
    },
  });
  const handleSubmit = async (values) => {
    setIsLoading(true);
    const data = {
      password: values.oldPassword,
      newPassword: values.newPassword,
      username: username,
    };
    const password = await Authentication.resetPassword(data);
    if (!password.error) {
      dispatch(initUsername());
      navigate("/login");
      showSuccess(t("resetPassword.successChangePassword"));
    } else {
      showError(get(password, "error.messageCode", "ER000"));
    }
    setIsLoading(false);
  };
  return (
    <>
      <Row type="flex" justify="center" align="top">
        <Col>
          <Row type="flex" justify="center">
            <Text className="title-reset-password" level={3}>
              {t("resetPassword.title")}
            </Text>
          </Row>

          <Row type="flex" justify="left">
            <label className="label-reset-password" htmlFor="oldPassword">
              {t("resetPassword.oldPassword")}
            </label>
          </Row>
          <Input.Password
            id="oldPassword"
            name="oldPassword"
            placeholder={t("resetPassword.oldPassword")}
            className="input-reset-password-first"
            onChange={formikLogin.handleChange}
            onBlur={formikLogin.handleBlur}
            value={formikLogin.values.oldPassword}
          />

          <Row>
            <Col span={12}>
              <label className="label-reset-password" htmlFor="newPassword">
                {t("resetPassword.newPassword")}
              </label>
            </Col>
            <Col span={12} className="right">
              <Tooltip
                title={
                  <div>
                    <p>{t("userSupplier.passwordRequirements.minLenght")}</p>
                    <ul>
                      <li>{t("userSupplier.passwordRequirements.minChar")}</li>
                      <li>{t("userSupplier.passwordRequirements.maxChar")}</li>
                      <li>{t("userSupplier.passwordRequirements.number")}</li>
                      <li>{t("userSupplier.passwordRequirements.specialChar")}</li>
                    </ul>
                  </div>
                }
              >
                <InfoCircleOutlined className="icon-small" />
              </Tooltip>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Input.Password
                id="newPassword"
                name="newPassword"
                placeholder={t("resetPassword.newPassword")}
                className="input-reset-password"
                onChange={formikLogin.handleChange}
                onBlur={formikLogin.handleBlur}
                value={formikLogin.values.newPassword}
              />
            </Col>
            <Col span={24}>
              <PasswordStrenght password={formikLogin.values.newPassword} />
            </Col>
          </Row>

          <Row type="flex" justify="left">
            <label className="label-reset-password" htmlFor="confirmNewPassword">
              {t("resetPassword.ConfirmNewPassword")}
            </label>
          </Row>
          <Input.Password
            id="confirmNewPassword"
            name="confirmNewPassword"
            placeholder={t("resetPassword.ConfirmNewPassword")}
            className="input-reset-password"
            onChange={formikLogin.handleChange}
            onBlur={formikLogin.handleBlur}
            value={formikLogin.values.confirmNewPassword}
          />

          <Row type="flex" justify="center">
            <PFButton
              type="primary"
              currentIcon={<LoginOutlined className="icon-medium" />}
              currentSize="large"
              className="button-reset-password"
              clickCallback={formikLogin.submitForm}
              isLoading={isLoading}
              isDisabled={!(formikLogin.dirty && formikLogin.isValid)}
            />
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default ResetPassword;
